export const init = () => {
  /* SHOPPING TOOL - NAVIGATION */

  const fwk = CUBE.Analytics;

  const stType = 'navigation';

  // CLICK on navigation menu link
  $('#menu-global').on(
    'click.st',
    'a[href^="/"][data-submenu],a[href^="/"][role="menuitem"],a.sport-link',
    function() {
      let urlCategory = fwk.utils.getInfoNavFromURLForShoppingTool(
        $(this).attr('href')
      );
      if (
        urlCategory !== null &&
        urlCategory !== '' &&
        urlCategory.endsWith('_')
      ) {
        urlCategory = urlCategory.substr(0, urlCategory.length - 2);
      }

      if (urlCategory !== null && urlCategory !== '') {
        const splitUrlCategory = urlCategory.split('/');
        urlCategory = splitUrlCategory[splitUrlCategory.length - 1];
      }

      CUBE.Analytics.shoppingtool.set(stType, urlCategory);
    }
  );
};



// WEBPACK FOOTER //
// ./src/analytics/shopping-tool/st-navigation.js